import { create } from 'zustand';

interface SnackbarState {
    isSnackbarOpen: boolean;
    snackbarMessage: string;
    setIsSnackbarOpen: (open: boolean) => void;
    setSnackbarMessage: (message: string) => void;
}

// Create the Zustand store with types
const snackbarStore = create<SnackbarState>((set) => ({
    isSnackbarOpen: false,
    snackbarMessage: '',
    setIsSnackbarOpen: (open: boolean) => set({ isSnackbarOpen: open }),
    setSnackbarMessage: (message: string) => set({ snackbarMessage: message, isSnackbarOpen: true }), // Automatically opens snackbar when message is set
}));

export default snackbarStore;
